import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RemindersSchema } from "./components/TileSkeleton/interface";
import dayjs from "dayjs";
import { getReminderTileData } from "src/api/sp";
import { resetStore } from "src/store/actions";

export const fetchReminderTileData = createAsyncThunk(
  "dashboard/fetchReminderTileData",
  ({
    departmentId,
    storeId,
    createdDate
  }: {
    departmentId: string;
    storeId: string;
    createdDate: string;
  }) => {
    return getReminderTileData({ departmentId, storeId, createdDate });
  }
);

type ReminderInitialState = {
  loading: string;
  reminderData: RemindersSchema;
  currentDate: string;
  error: string;
};

const initialState: ReminderInitialState = {
  loading: "idle",
  reminderData: { count: 0, reminders: [] },
  currentDate: dayjs().format("YYYY-MM-DD"),
  error: ""
};

const ReminderTileSlice = createSlice({
  name: "ReminderTile",
  initialState,
  reducers: {
    reminderForTheDay: (state: any, action: any) => {},
    setCurrentDate: (state: any, action: any) => {
      state.currentDate = action.payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchReminderTileData.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchReminderTileData.fulfilled, (state, { payload }) => {
        if (payload.success) {
          state.reminderData = payload.data;
          state.loading = "idle";
          state.error = "";
        } else {
          state.reminderData = initialState.reminderData;
          state.loading = "idle";
          state.error = "No reminders found";
        }
      })
      .addCase(fetchReminderTileData.rejected, (state, action) => {
        state.error = "error";
      });
  }
});
export const { setCurrentDate } = ReminderTileSlice.actions;
export default ReminderTileSlice.reducer;
